import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  PageHeaderAction,
  PageHeaderComponent,
  PageHeaderIconConfig,
} from '../page-header/page-header.component';

/**
 * Contenedor de página (cabecera + cuerpo), alineado con el patrón ERP (page-container + page-header).
 */
@Component({
  selector: 'app-page-container',
  standalone: true,
  imports: [CommonModule, PageHeaderComponent],
  templateUrl: './page-container.component.html',
  styleUrls: ['./page-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageContainerComponent {
  title = input.required<string>();
  subtitle = input<string>('');
  icon = input<string | PageHeaderIconConfig | undefined>(undefined);
  actions = input<PageHeaderAction[]>([]);
  action = output<string>();
}
